import React from "react";

import { NodeIcon } from "src/design-system/NodeIcon";
import { Pill } from "src/design-system/Pill";

type SdkScriptPillProps = {
  name: string;
  iconSrc?: string;
  // When > 0, an inline "+N more" suffix is rendered inside the same pill to
  // summarise the bundle's remaining member scripts (Figma node 306:2502).
  moreCount?: number;
  dataLoc?: string;
};

export const SdkScriptPill: React.FC<SdkScriptPillProps> = ({
  name,
  iconSrc,
  moreCount,
  dataLoc,
}) => (
  <Pill
    dataLoc={dataLoc ?? "sdk-script-pill"}
    maxWidth
    size="sm"
    variant="gray"
  >
    {iconSrc && <NodeIcon imageSrc={iconSrc} size="xs" />}
    <Pill.Text>{name}</Pill.Text>
    {moreCount !== undefined && moreCount > 0 && (
      <span className="shrink-0 font-inter-medium-12px">
        {`+${moreCount} more`}
      </span>
    )}
  </Pill>
);
